import { FC } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

interface Props {
  onClose: () => void;
}

export const DebtInfoModal: FC<Props> = ({ onClose }) => {
  return (
    <Stack pt="10px" spacing={0}>
      <Text fontSize="14px" textAlign="center">
        Сумма задолженности меняется, потому что проценты начисляются каждый день
      </Text>

      <Button onClick={onClose} mt="22px">Понятно</Button>
    </Stack>
  );
};
